import { LibraryTabs, QUERY_LIBRARY_TAB } from './index.h'

function getQueryTab(query: URLSearchParams) {
  return query.get(QUERY_LIBRARY_TAB) as LibraryTabs | null
}

export function getLibraryTabFromQuery(query: URLSearchParams) {
  const libraryTab = getQueryTab(query)
  return libraryTab ?? LibraryTabs.FAVORITES
}

export function isQueryTabNotEqualNextTab(
  query: URLSearchParams,
  nextTab: LibraryTabs
) {
  const queryTab = getQueryTab(query)
  return nextTab !== queryTab
}
